import { createUUID } from "../Misc";
import { nodedxf2 } from "../Drawing";
export class BookOrder {
    constructor(book) {
        this.qty = 1;
        this.cuts = 0;
        this.cuttingLength = 0;
        this.selMaterial = null;
        this.delete = false;
        this.color = null;
        this.gluing = false;
        this.welding = false;
        this.assembly = false;
        this.bends = [];
        this.bulkOrderWarning = false;
        this.book = null;
        this.bookfile = null;
        this.display = null;
        this.drawing = null;
        this.key = "";
        this.isNew = false;
        this.SetupFee = null;
        this.RawSetupFee = 0;
        this.book = book;
        this.bookfile = book.path().join(':');
        this.display = book.display;
        this.key = createUUID();
        this.isNew = true;
        this.drawing = nodedxf2(book.dxf);
    }
}
